import { AssetTypeName } from '../../../portfolio/utils/types';
import {
  GlobalCoinLogo,
  GlobalMetalLogo,
  GlobalEtfLogo,
  GlobalEtcLogo,
  GlobalStockLogo,
} from '../../assets';

export const assetImageByName = {
  [AssetTypeName.COIN]: GlobalCoinLogo,
  [AssetTypeName.METAL]: GlobalMetalLogo,
  [AssetTypeName.ETF]: GlobalEtfLogo,
  [AssetTypeName.ETC]: GlobalEtcLogo,
  [AssetTypeName.STOCK]: GlobalStockLogo,
};

export enum PortfolioAssetOnClickActions {
  GO_TO_ASSET_DETAILS = 'DETAILS',
  GO_TO_MY_ASSETS = 'MY_ASSETS',
  GO_TO_SWAP = 'SWAP',
}
